import styled from "styled-components";

export const Container = styled.div<{selected: boolean}>`
  display: flex; 
  align-items: center;
  justify-content: space-between;
  padding: 8px 10px;
  width: fit-content;
  border-radius: 32px; 
  background-color: ${props => props.selected ? props.theme.colors.primaryLight : props.theme.colors.white};
  border: 1px solid;
  border-color: ${props => props.selected ? props.theme.colors.primary : props.theme.colors.placeholder};
  cursor: pointer;
  gap: 16px;
  min-width: 102px;
`;

export const IconContainer = styled.div`
  &:hover{
    cursor: pointer;
  }
`;